import { Component, Input, OnInit } from '@angular/core';
import { ThemeService } from 'vhobjects-service/src/services';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';

@Component({
  selector: 'atw-text-connector-row-repeat-config',
  templateUrl: './text-connector-row-repeat-config.component.html',
  styleUrls: ['./text-connector-row-repeat-config.component.scss']
})
export class AtwTextConnectorRowRepeatConfig implements OnInit {
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() type: any; // xem đang ở page hay admin

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'cau_hinh_bo_goc',
      index: 0,
    }
  ];
  effect_hover = [];
  effect_hover_data: any = {};
  id_subproject: any = "";

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhEventMediator: VhEventMediator,
    public themeService: ThemeService,
  ) { }

  ngOnInit(): void { }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => { })
  }

  /**
   * Hàm update class
   */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => { })
  }

  /**
   * Hàm update config
   */
  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => { })
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => { });
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['text-connector-row']['width'] = event.width + 'px';
    if (event.height) this.class['text-connector-row']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }
}
